<div class="incident-details-modal" *transloco="let t; prefix: 'accidents.modals.incidentDetails'">
  <div class="incident-details-modal__header">
    <h3 class="incident-details-modal__title">{{ title }}</h3>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="close()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  <div class="incident-details-modal__map">
    <app-common-map
      [data]="mapData"
      [initialCenter]="mapCenter"
      [focusPositions]="mapData"
      [markerFactory]="markerFactory"
      [mapHeight]="mapHeight"
      [mapTypeId]="'satellite'"
      [disableClustering]="true"
      [showDropdown]="false"
      [canExpandMap]="false">
    </app-common-map>

    <div class="location-card">
      <div class="location-card__item location-card__item--location">
        <span class="location-card__label">
          <i class="ph ph-map-pin-area" aria-hidden="true"></i>
          {{ t('location') }}
        </span>
        <span class="location-card__value" [attr.title]="locationText || null">
          <i class="ph ph-warning location-card__warning" aria-hidden="true"></i>
          <span class="location-card__text">{{ locationText || emptyValue }}</span>
        </span>
      </div>

      <div class="location-card__item location-card__item--coordinate">
        <span class="location-card__label">
          <i class="ph ph-warning-circle" aria-hidden="true"></i>
          {{ t('longitude') }}
        </span>
        <span class="location-card__value">{{ (longitude | number: coordinateFormat) ?? emptyValue }}</span>
      </div>

      <div class="location-card__item location-card__item--coordinate">
        <span class="location-card__label">
          <i class="ph ph-clock-afternoon" aria-hidden="true"></i>
          {{ t('latitude') }}
        </span>
        <span class="location-card__value">{{ (latitude | number: coordinateFormat) ?? emptyValue }}</span>
      </div>
    </div>
  </div>
</div>